import React from "react";
import { Route } from "react-router-dom";
import withTracker from "../components/GoogleAnalytics";
import { OtherRoutes } from "./OtherRoutes";
import { AuthRoutes } from "./AuthRoutes";
import { ApplicationRoutes } from "./ApplicationsRoutes";
import { OptionRoutes } from "./OptionRoutes";
import { ReportRoutes } from "./ReportRoutes";
import { ShipperRoutes } from "./ShipperRoutes";
import generatedRoute from "src/generated/route";

const allRoutes: any[] = [...OtherRoutes, ...ApplicationRoutes, ...OptionRoutes, ...ReportRoutes, ...generatedRoute];
const onlyAuthRoutes: any[] = [...AuthRoutes];
const shipperRoutes: any[] = [...ShipperRoutes];

export function createRoutes() {
  return allRoutes.map((x) => {
    return <Route {...x} key={x.path} component={withTracker(x.component)} />;
  });
}

export function createRoutesAuth() {
  return onlyAuthRoutes.map((x) => {
    return <Route {...x} key={x.path} component={x.component} />;
  });
}

export function createRoutesShipperLogic() {
  return shipperRoutes.map((x) => {
    return <Route {...x} key={x.path} component={x.component} />;
  });
}

export function createRouteShipper() {
  const routes = [
    { path: "/", exact: true, component: React.lazy(() => import("src/screens/shipper/order/list")) },
    { path: "/detail/:id", exact: true, component: React.lazy(() => import("src/screens/shipper/order/detail")) },
    { path: "/inventory", exact: true, component: React.lazy(() => import("src/screens/shipper/inventory/list")) },
    {
      path: "/inventory/:id",
      exact: true,
      component: React.lazy(() => import("src/screens/shipper/inventory/detail")),
    },
    { path: "/package_seller", exact: true, component: React.lazy(() => import("src/screens/shipper/package/list")) },
  ];

  return routes.map((x) => {
    return <Route {...x} key={x.path} component={x.component} />;
  });
}
